__webpack_require__.p = "/reports-sidebar-fixed-addnew-button/referrals-hub/";